import React from "react";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Typography } from "@mui/material";

const UpdateButton = (props: {onClick?: () => void}) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        } else {
          window.location.reload()
        }
      }}
      sx={{
        marginLeft: "auto",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography variant="body2" padding={0.5}>
        一覧更新
      </Typography>

      <RefreshIcon fontSize="small" />
    </Button>
  );
};

export default UpdateButton;
